export const testIdMap = {
  DASHBOARD_EMAIL_EDITOR__FORM_SCREEN: 'DASHBOARD_EMAIL_EDITOR__FORM_SCREEN',
  DASHBOARD_EMAIL_EDITOR__SUCCEEDED_SCREEN:
    'DASHBOARD_EMAIL_EDITOR__SUCCEEDED_SCREEN',
  DASHBOARD_EMAIL_EDITOR__LOGIN_INPUT: 'DASHBOARD_EMAIL_EDITOR__LOGIN_INPUT',
  DASHBOARD_EMAIL_EDITOR__LOGIN_VALIDATION:
    'DASHBOARD_EMAIL_EDITOR__LOGIN_VALIDATION',
  DASHBOARD_EMAIL_EDITOR__PASSWORD_INPUT:
    'DASHBOARD_EMAIL_EDITOR__PASSWORD_INPUT',
  DASHBOARD_EMAIL_EDITOR__PASSWORD_VALIDATION:
    'DASHBOARD_EMAIL_EDITOR__PASSWORD_VALIDATION',
  DASHBOARD_EMAIL_EDITOR__SUBMIT_BUTTON:
    'DASHBOARD_EMAIL_EDITOR__SUBMIT_BUTTON',
  DASHBOARD_EMAIL_EDITOR__CANCEL_BUTTON:
    'DASHBOARD_EMAIL_EDITOR__CANCEL_BUTTON',
  DASHBOARD_EMAIL_EDITOR__PENDING_INDICATOR:
    'DASHBOARD_EMAIL_EDITOR__PENDING_INDICATOR',
  DASHBOARD_EMAIL_EDITOR__SUCCEEDED_INDICATOR:
    'DASHBOARD_EMAIL_EDITOR__SUCCEEDED_INDICATOR',

  DASHBOARD_PASSWORD_EDITOR__ACTUAL_PASSWORD_INPUT:
    'DASHBOARD_PASSWORD_EDITOR__ACTUAL_PASSWORD_INPUT',
  DASHBOARD_PASSWORD_EDITOR__ACTUAL_PASSWORD_VALIDATION:
    'DASHBOARD_PASSWORD_EDITOR__ACTUAL_PASSWORD_VALIDATION',
  DASHBOARD_PASSWORD_EDITOR__NEXT_PASSWORD_INPUT:
    'DASHBOARD_PASSWORD_EDITOR__NEXT_PASSWORD_INPUT',
  DASHBOARD_PASSWORD_EDITOR__NEXT_PASSWORD_VALIDATION:
    'DASHBOARD_PASSWORD_EDITOR__NEXT_PASSWORD_VALIDATION',
  DASHBOARD_PASSWORD_EDITOR__NEXT_PASSWORD_REPEAT_INPUT:
    'DASHBOARD_PASSWORD_EDITOR__NEXT_PASSWORD_REPEAT_INPUT',
  DASHBOARD_PASSWORD_EDITOR__NEXT_PASSWORD_REPEAT_VALIDATION:
    'DASHBOARD_PASSWORD_EDITOR__NEXT_PASSWORD_REPEAT_VALIDATION',
  DASHBOARD_PASSWORD_EDITOR__SUBMIT_BUTTON:
    'DASHBOARD_PASSWORD_EDITOR__SUBMIT_BUTTON',
  DASHBOARD_PASSWORD_EDITOR__CANCEL_BUTTON:
    'DASHBOARD_PASSWORD_EDITOR__CANCEL_BUTTON',
  DASHBOARD_PASSWORD_EDITOR__PENDING_INDICATOR:
    'DASHBOARD_PASSWORD_EDITOR__PENDING_INDICATOR',
  DASHBOARD_PASSWORD_EDITOR__SUCCEEDED_INDICATOR:
    'DASHBOARD_PASSWORD_EDITOR__SUCCEEDED_INDICATOR',

  CREATE_PROD_STACK__DOMAIN_INPUT: 'CREATE_PROD_STACK__DOMAIN_INPUT',
  CREATE_PROD_STACK__DOMAIN_VALIDATION: 'CREATE_PROD_STACK__DOMAIN_VALIDATION',
  CREATE_PROD_STACK__SUBMIT_BUTTON: 'CREATE_PROD_STACK__SUBMIT_BUTTON',
  CREATE_PROD_STACK__CANCEL_BUTTON: 'CREATE_PROD_STACK__CANCEL_BUTTON',
  CREATE_PROD_STACK__PENDING_INDICATOR: 'CREATE_PROD_STACK__PENDING_INDICATOR',
  CREATE_PROD_STACK__SUCCEEDED_INDICATOR:
    'CREATE_PROD_STACK__SUCCEEDED_INDICATOR',

  REGISTRATION_PASSWORD__PASSWORD_INPUT:
    'REGISTRATION_PASSWORD__PASSWORD_INPUT',
  REGISTRATION_PASSWORD__PASSWORD_VALIDATION:
    'REGISTRATION_PASSWORD__PASSWORD_VALIDATION',
  REGISTRATION_PASSWORD__PASSWORD_REPEAT_INPUT:
    'REGISTRATION_PASSWORD__PASSWORD_REPEAT_INPUT',
  REGISTRATION_PASSWORD__PASSWORD_REPEAT_VALIDATION:
    'REGISTRATION_PASSWORD__PASSWORD_REPEAT_VALIDATION',
  REGISTRATION_PASSWORD__SUBMIT_BUTTON: 'REGISTRATION_PASSWORD__SUBMIT_BUTTON',
  REGISTRATION_PASSWORD__PENDING_INDICATOR:
    'REGISTRATION_PASSWORD__PENDING_INDICATOR',
  REGISTRATION_PASSWORD__SUCCEEDED_INDICATOR:
    'REGISTRATION_PASSWORD__SUCCEEDED_INDICATOR',

  CLIENTS_PAGE__WRAPPER: 'CLIENTS_PAGE__WRAPPER',
  CLIENTS_PAGE__CONTROLS: 'CLIENTS_PAGE__CONTROLS',
  CLIENTS_PAGE__SEARCH: 'CLIENTS_PAGE__SEARCH',

  CLIENTS_TABLE__WRAPPER: 'CLIENTS_TABLE__WRAPPER',

  CLIENT_DETAILS__TITLE: 'CLIENT_DETAILS__TITLE',
  CLIENT_DETAILS__EDIT_PROFILE_BUTTON: 'CLIENT_DETAILS__EDIT_PROFILE_BUTTON',
  CLIENT_DETAILS__EDIT_LOGIN_BUTTON: 'CLIENT_DETAILS__EDIT_LOGIN_BUTTON',
  CLIENT_DETAILS__EDIT_PASSWORD_BUTTON: 'CLIENT_DETAILS__EDIT_PASSWORD_BUTTON',
  CLIENT_DETAILS__ARCHIVE_BUTTON: 'CLIENT_DETAILS__ARCHIVE_BUTTON',
  CLIENT_DETAILS__PROFILE_EDITOR_BLOCK: 'CLIENT_DETAILS__PROFILE_EDITOR_BLOCK',
  CLIENT_DETAILS__LOGIN_EDITOR_BLOCK: 'CLIENT_DETAILS__LOGIN_EDITOR_BLOCK',
  CLIENT_DETAILS__PASSWORD_EDITOR_BLOCK:
    'CLIENT_DETAILS__PASSWORD_EDITOR_BLOCK',
  CLIENT_DETAILS__ARCHIVE_PENDING_INDICATOR:
    'CLIENT_DETAILS__ARCHIVE_PENDING_INDICATOR',
  CLIENT_DETAILS__ARCHIVE_RESOLVED_INDICATOR:
    'CLIENT_DETAILS__ARCHIVE_RESOLVED_INDICATOR',
  CLIENT_DETAILS__PROFILE_EDITOR_CANCEL_BUTTON:
    'CLIENT_DETAILS__PROFILE_EDITOR_CANCEL_BUTTON',
  CLIENT_DETAILS__LOGIN_EDITOR_CANCEL_BUTTON:
    'CLIENT_DETAILS__LOGIN_EDITOR_CANCEL_BUTTON',
  CLIENT_DETAILS__PASSWORD_EDITOR_CANCEL_BUTTON:
    'CLIENT_DETAILS__PASSWORD_EDITOR_CANCEL_BUTTON',

  PARTNERS_PAGE__WRAPPER: 'PARTNERS_PAGE__WRAPPER',
  PARTNERS_PAGE__CONTROLS: 'PARTNERS_PAGE__CONTROLS',
  PARTNERS_PAGE__SEARCH: 'PARTNERS_PAGE__SEARCH',

  PARTNERS_TABLE__WRAPPER: 'PARTNERS_TABLE__WRAPPER',
};
